import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import SharedPropsService from "../../../SharedPropsService";
import { InputStateToken } from "@voltmoney/schema";
import _ from "lodash";
import { ACTION } from "../withdraw_amount/types";
export const CreateDisbursementRequest = async (action, _datastore, { network, showPopup, setDatastore }) => {
    await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
        state: InputStateToken.DEFAULT,
    });
    const resendOtpResponse = await network.post(api.lmsDisbursalV2, {
        creditId: (await SharedPropsService.getUser()).linkedCredits[0].creditId,
        disbursalAmount: await SharedPropsService.getDisbursalAmount(),
    }, { headers: await getAppHeader() });
    if (_.get(resendOtpResponse, "data.status") === "SUCCESS") {
        await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
            state: InputStateToken.DEFAULT,
        });
    }
    if (resendOtpResponse?.response?.status === 400) {
        if (resendOtpResponse?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
            const errorMessage = resendOtpResponse?.response?.data?.message;
            showPopup({
                title: errorMessage,
                type: 'FAILED',
                ctaLabel: 'Go back',
                ctaAction: {
                    routeId: ROUTE.ALERT_PAGE,
                    type: ACTION.CLOSE_POPUP,
                    payload: {}
                },
                primary: true
            });
        }
    }
};
export const DisbursalVerifyAction = async (action, _datastore, { navigate, network, setDatastore, goBack, instrumentTrack }) => {
    const noOfOtpDigits = action?.payload?.noOfOtpDigits;
    if (`${action.payload.value}`.length > (noOfOtpDigits - 1)) {
        await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
            state: InputStateToken.LOADING,
        });
        const response = await network.post(api.lmsDisbursalVerify, {
            otp: action.payload.value,
            phoneNo: (await SharedPropsService.getUser()).linkedBorrowerAccounts[0].accountHolderPhoneNumber,
        }, { headers: await getAppHeader() }, async () => {
            await setDatastore(ROUTE.WITHDRAW_AMOUNT, "amountItem", {
                state: InputStateToken.DEFAULT,
            });
        });
        if (response.status === 200) {
            await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
                state: InputStateToken.SUCCESS,
            });
            goBack();
            goBack();
            await navigate(ROUTE.WITHDRAWAL_SUCCESS, {
                disbursalAmount: await SharedPropsService.getDisbursalAmount(),
                accountNumber: action.payload.accountNumber,
            });
        }
        else {
            if (response?.response?.status === 400) {
                if (response?.response?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP') {
                    await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
                        state: InputStateToken.DISABLED,
                        caption: { error: response?.response?.data?.message },
                        otpLimitExceeded: true
                    });
                }
                else {
                    await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
                        state: InputStateToken.ERROR,
                        caption: { error: response?.response?.data?.message }
                    });
                }
            }
            else {
                await setDatastore(ROUTE.WITHDRAWAL_OTP, "otpModalScreen", {
                    state: InputStateToken.ERROR,
                    caption: { error: response?.response?.data?.message }
                });
            }
        }
    }
};
export const goBack = async (action, _datastore, { setDatastore, goBack }) => {
    await setDatastore(ROUTE.WITHDRAW_AMOUNT, "otpModalScreen", {
        state: InputStateToken.DEFAULT,
        caption: {},
    });
    await goBack();
};
